import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSheet,{staticClass:"details-panel elevation-2 mt-2 px-4 pt-3 pb-4",attrs:{"color":"white","rounded":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }